import './print.scss';
import { useParams } from 'react-router';
import ViewExamPrint from 'modules/Print/QuestionModules/ViewExamPrint';

function Print_Page() {
  const { template_name } = useParams<{ template_name: string }>();

  const RenderContentPage = () => {
    switch (template_name) {
      case 'exam':
        return <ViewExamPrint />;
      default:
        return <div />;
    }
  };

  /* Các thành phần không in ra thì sẽ gắn class = 'no-print' */
  return (
    <div id='print_page_container'>
      <div className='surrounding A4_alignment'>
        <RenderContentPage />
      </div>
    </div>
  );
}

export default Print_Page;
